module.exports = __webpack_public_path__ + "assets/img/cfban.d324804.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pagesInvestment/cfban.png
// module id = jvvb
// module chunks = 128